// @flow
import * as React from 'react';
import { Prompt } from 'react-router-dom';

type Props = { dirty: boolean };
type State = { mounted: boolean };

export default function confirmDiscardForm(
  WrappedComponent: React.AbstractComponent<Props>,
  allowedRoute: string = '###'
): React.AbstractComponent<Props> {
  class hocComponent extends React.Component<Props, State> {
    state = { mounted: false };
    componentDidMount() {
      this.setState({ mounted: true });
      window.addEventListener('beforeunload', this.handleUnload);
    }
    componentWillUnmount() {
      window.removeEventListener('beforeunload', this.handleUnload);
    }

    handleUnload = event => {
      if (this.props.dirty) {
        event.preventDefault();
        event.returnValue = '';
      }
    };
    render() {
      return (
        <>
          <WrappedComponent {...this.props} />
          <Prompt
            // workaround to avoid warning from react-router https://github.com/ReactTraining/react-router/issues/5707
            when={this.state.mounted && this.props.dirty}
            message={location =>
              location.pathname.startsWith(allowedRoute)
                ? true
                : 'You have unsaved changes. Are you sure you want to leave?'
            }
          />
        </>
      );
    }
  }
  return hocComponent;
}
